import React from "react";
import { Container, Box, Typography, Divider } from "@mui/material";
import { Link } from "react-router-dom";

export default function KesnerMichelThermesi() {
  return (
    <Container maxWidth="md">
      <Box sx={{ mt: 4, mb: 6 }}>

        {/* Lien retour */}
         <Link
           to="/ecole/gouvernance"
           style={{
                display: "inline-block",
                background: "#FFD84D",
                color: "#0B2C5F",
                padding: "8px 16px",
                borderRadius: "6px",
                fontWeight: "600",
                textDecoration: "none",
                marginBottom: "20px"
            }}
     >
          ← Retour à la gouvernance
        </Link>

        {/* En-tête profil */}
        <Box sx={{ textAlign: "center", mt: 3, mb: 5 }}>
          <img
            src="/gouvernance/directeur-partenariats.jpg"
            alt="Kesner Michel Thermesi"
            style={{
              width: "240px",
              borderRadius: "14px",
              marginBottom: "20px",
            }}
          />

          <Typography variant="h4" sx={{ fontWeight: 900, color: "#0B2C5F" }}>
            Kesner Michel Thermesi
          </Typography>

          <Typography sx={{ color: "text.secondary", mt: 1 }}>
            Directeur des Partenariats – École de la Magistrature
          </Typography>

          <Typography sx={{ color: "text.secondary" }}>
            Spécialiste en relations internationales et développement
          </Typography>
        </Box>

        <Typography variant="h5" sx={{ fontWeight: 800, color: "#0B2C5F", mb: 2 }}>
          Présentation
        </Typography>

        <Typography paragraph>
          Diplômé en relations internationales avec plus de 12 ans d'expérience dans la coopération internationale, 
          Kesner Michel Thermesi est spécialisé dans le développement de partenariats institutionnels et la 
          mobilisation de ressources. Il est titulaire d'une maîtrise en relations internationales de l'Université 
          Quisqueya et d'un diplôme d'études supérieures en gestion de projets de développement.
        </Typography>

        <Divider sx={{ my: 4 }} />

        <Typography variant="h5" sx={{ fontWeight: 800, color: "#0B2C5F", mb: 2 }}>
          Formation académique et perfectionnement
        </Typography>

        <Typography paragraph>
          Sa formation inclut des études approfondies en diplomatie multilatérale et coopération bilatérale. 
          Il a suivi des programmes de perfectionnement en négociation internationale et gestion des bailleurs 
          de fonds à l'Institut des hautes études internationales. Il est également certifié en gestion 
          de projets selon les standards internationaux PMD Pro.
        </Typography>

        <Divider sx={{ my: 4 }} />

        <Typography variant="h5" sx={{ fontWeight: 800, color: "#0B2C5F", mb: 2 }}>
          Parcours professionnel
        </Typography>

        <Typography paragraph>
          Avant son arrivée à l'École de la Magistrature, Kesner Michel Thermesi a travaillé pour plusieurs 
          organisations internationales et ONG en Haïti, où il a développé des partenariats stratégiques et 
          géré des programmes de développement. Il a également occupé des fonctions de coordination au sein 
          du Ministère des Affaires étrangères.
        </Typography>

        <Divider sx={{ my: 4 }} />

        <Typography variant="h5" sx={{ fontWeight: 800, color: "#0B2C5F", mb: 2 }}>
          Responsabilités à l'EMA
        </Typography>

        <Typography paragraph>
          Le directeur des partenariats développe et maintient les relations avec les institutions nationales 
          et internationales, les partenaires académiques et les bailleurs de fonds. Il est responsable de 
          la négociation et de la gestion des accords de partenariat pour le développement de l'école, ainsi 
          que de la mobilisation des ressources nécessaires à la mise en œuvre des programmes de formation.
        </Typography>

        <Divider sx={{ my: 4 }} />

        <Typography variant="h5" sx={{ fontWeight: 800, color: "#0B2C5F", mb: 2 }}>
          Affiliations et engagements
        </Typography>

        <Typography paragraph>
          Il est membre de la Société haïtienne de droit international et participe régulièrement à des 
          conférences sur la coopération internationale. Il est également impliqué dans des réseaux 
          régionaux de partenaires éducatifs pour le renforcement des capacités judiciaires.
        </Typography>
      </Box>
    </Container>
  );
}
